<ng-content *ngIf="isCanView; else elseBlock"></ng-content>

<ng-template #elseBlock>
  <ng-content select="[canViewExceptElse]"></ng-content>
</ng-template>
